<script setup lang="ts">
import { filename } from 'pathe/utils'

const { name } = defineProps({
  name: String,
  default: ''
})
const glob = import.meta.glob('@/assets/images/icons/*.svg', { eager: true })
const images = Object.fromEntries(
  Object.entries(glob).map(([key, value]) => [filename(key), value.default])
)
</script>

<template>
<img :src="images[name]" width="22" height="22" />
</template>

<style scoped lang="scss">

</style>
